import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export const IPTopBar: React.FC = () => {
  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-4 h-12 bg-background border-b"
      style={{
        paddingTop: 'env(safe-area-inset-top)',
        height: 'calc(3rem + env(safe-area-inset-top))',
        borderColor: 'var(--clue-border-light)',
      }}
    >
      <Link
        to="/"
        aria-label="Back to Wallstreetle"
        className="flex items-center gap-1 hover:opacity-80 transition-opacity"
        style={{ color: 'hsl(var(--foreground))' }}
      >
        <ChevronLeft className="w-5 h-5" />
        <span className="text-sm font-medium">Back</span>
      </Link>

      <span
        className="absolute left-1/2 -translate-x-1/2 font-serif text-lg tracking-tight"
        style={{ color: 'hsl(var(--foreground))' }}
      >
        Investment Philosophy
      </span>

      <div className="w-16" />
    </div>
  );
};
